import ClientVoucherModel from "src/models/ReservationClientVoucherModel";
import { setReservationClientVoucherVisibility, setReservationOverviewVisibility } from "../slices/hotels/HotelDetailSlice";

export const convertToClientVoucher = (results) => {
    return { ...new ClientVoucherModel(results) };
};

export const handleViewAllVoucher = (reservationId, voucherId, dispatch, navigate) => {
    dispatch(setReservationOverviewVisibility(false));
    dispatch(setReservationClientVoucherVisibility(true));
    navigate(`/reservations/${reservationId}/client-voucher/${voucherId}`);
};

export const handleViewSingleVoucher = (reservationId, voucherId, dispatch, navigate, itemReference) => {
    dispatch(setReservationOverviewVisibility(false));
    dispatch(setReservationClientVoucherVisibility(true));
    navigate(`/reservations/${reservationId}/client-voucher/${voucherId}/voucher-items/${itemReference}`);
};
